import api from '@/api/index.js'

const tickets_stats = {
  state: {
    loading: false,
    data: [],
    error: null,
  },

  mutations: {
    SET_TICKETS_STATS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_TICKETS_STATS: (state, data) => {
      state.data = data
    },
    SET_TICKETS_STATS_ERROR: (state, error) => {
      state.error = error
    }
  },

  actions: {
    GetTicketsStatisticsForPeriod({commit}, query) {
      commit('SET_TICKETS_STATS_LOADING', true)
      commit('SET_TICKETS_STATS_ERROR', null)
      return api.get(`stats/tickets?period=${query}`)
        .then((response) => {
          commit('SET_TICKETS_STATS', response)
          commit('SET_TICKETS_STATS_LOADING', false)
        })
        .catch((error) => {
          commit('SET_TICKETS_STATS_ERROR', error)
          commit('SET_TICKETS_STATS_LOADING', false)
        })
    },
  },
}

export default tickets_stats
